module.exports = __webpack_public_path__ + "static/media/Team-Shiv.a0b5f7ae.jpg";